exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DnDJFLHemBYsFztEsMWMr{max-width:100%;display:block;height:auto;width:512px}\n", ""]);
// Exports
exports.locals = {
	"myImage": "DnDJFLHemBYsFztEsMWMr"
};